import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ContactService } from '../../../core/services/contact/contact/contact.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ContactTypeService } from '../../../core/services/contact/contact-type/contact-type.service'

@Component({
  selector: 'contact-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
  ],
  templateUrl: './contact-edit.component.html',
  styleUrl: './contact-edit.component.scss',
  providers: [ContactService, ContactTypeService],
  standalone: true,
})
export class ContactEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private contactService: ContactService,
    private contactTypeService: ContactTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ContactEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
    this.listTypeContact()
  }

  listTypeContact() {
    this.contactTypeService.listContactType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.contactService.editContact(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.itemEdit.id,
      pessoaId: 0,
      descricao: this.form.controls['description'].value,
      tipoContatoId: this.form.controls['typeContact'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      description: [this.itemEdit.descricao, [Validators.required]],
      typeContact: [this.itemEdit.tipoContatoId, [Validators.required]],
    })
    this.form.get('code')?.disable()
  }
}
